
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-information-agreement-freelance',
  templateUrl: './information-agreement-freelance.component.html',
  styleUrls: ['./information-agreement-freelance.component.scss']
})
export class InformationAgreementFreelanceComponent implements OnInit {
  @Output()
  accept = new EventEmitter();

  accepted = false;
  medicalConsultantAccepted = false;

  constructor() { }

  ngOnInit(): void {
  }

  public allAccepted = () => {
    return this.accepted && this.medicalConsultantAccepted;
  }
  public onAccept = () => {
    this.accept.emit();
  }
}
